import localforage from 'localforage';
import { createRoot } from 'react-dom/client';
import 'reflect-metadata';
import { Container } from 'typedi';
import { appEnvironmentSchema } from './config/app-environment';
import { ContainerTokens, LOCAL_STORAGE_INSTANCE_NAME } from './constants';
import { createPrayerStreamStore } from './core/store';
import './index.css';
import { AppProviders } from './providers/AppProviders/AppProviders';

// eslint-disable-next-line unicorn/prefer-top-level-await -- Not supported in Safari
void (async () => {
  const persistentStorageEngine = localforage.createInstance({
    name: LOCAL_STORAGE_INSTANCE_NAME,
  });
  const container = Container.of(ContainerTokens.DEFAULT_CONTAINER.name);
  container.set(ContainerTokens.PROCESS_ENV, import.meta.env);
  container.set(ContainerTokens.ENVIRONMENT_SCHEMA, appEnvironmentSchema);
  container.set(
    ContainerTokens.PERSISTENT_STORAGE_ENGINE,
    persistentStorageEngine,
  );

  const store = await createPrayerStreamStore({ container });
  const rootContainer = document.querySelector('#root');
  if (rootContainer) {
    const root = createRoot(rootContainer);
    root.render(<AppProviders container={container} store={store} />);
  }
})();
